import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { GuardsService } from '../services/guards.service';
import { UserService } from '../services/user.service';

@Injectable({
    providedIn: 'root'
})
export class LoggedOutGuard implements CanActivate {
    constructor(private userService: UserService, private router: Router, private guardsService: GuardsService) {}
    canActivate(): boolean | UrlTree {
        if (this.userService.userData === null) {
            return true;
        }
        return this.router.createUrlTree(this.guardsService.logoutGuardRedirectCommands);
    }
}
